export type ScreenSize = "xs" | "s" | "m" | "l" | "xl";

export interface ChartConfig {
  height: number;
  padding: { top: number; bottom: number; left: number; right: number };
  domainPaddingX: number;
  yFactor: number;
  barWidth: number;
  cornerRadius: { top: number; bottom: number };
  fontSize: { tick: number };
  tickPadding: number;
}

export const mobileConfigs: Record<ScreenSize, ChartConfig> = {
  xs: {
    height: 150,
    padding: { top: 8, bottom: 24, left: 0, right: 0 },
    domainPaddingX: 0,
    yFactor: 1,
    barWidth: 20,
    cornerRadius: { top: 3, bottom: 3 },
    fontSize: { tick: 12 },
    tickPadding: 2,
  },
  s: {
    height: 180,
    padding: { top: 10, bottom: 18, left: 0, right: 0 },
    domainPaddingX: 10,
    yFactor: 1,
    barWidth: 28,
    cornerRadius: { top: 3, bottom: 3 },
    fontSize: { tick: 18 },
    tickPadding: 2,
  },
  m: {
    height: 200,
    padding: { top: 12, bottom: 26, left: 0, right: 0 },
    domainPaddingX: 10,
    yFactor: 1,
    barWidth: 70,
    cornerRadius: { top: 3, bottom: 3 },
    fontSize: { tick: 18 },
    tickPadding: 2,
  },
  l: {
    height: 200,
    padding: { top: 12, bottom: 26, left: 0, right: 0 },
    domainPaddingX: 10,
    yFactor: 1,
    barWidth: 70,
    cornerRadius: { top: 3, bottom: 3 },
    fontSize: { tick: 18 },
    tickPadding: 2,
  },
  xl: {
    height: 200,
    padding: { top: 12, bottom: 26, left: 0, right: 0 },
    domainPaddingX: 10,
    yFactor: 1,
    barWidth: 70,
    cornerRadius: { top: 3, bottom: 3 },
    fontSize: { tick: 18 },
    tickPadding: 2,
  },
};

export const webConfigs: Record<ScreenSize, ChartConfig> = {
  xs: {
    height: 180,
    padding: { top: 8, bottom: 22, left: 0, right: 0 },
    domainPaddingX: 10,
    yFactor: 1,
    barWidth: 28,
    cornerRadius: { top: 1, bottom: 1 },
    fontSize: { tick: 16 },
    tickPadding: 2,
  },
  s: {
    height: 180,
    padding: { top: 10, bottom: 22, left: 0, right: 0 },
    domainPaddingX: 10,
    yFactor: 1,
    barWidth: 28,
    cornerRadius: { top: 1, bottom: 1 },
    fontSize: { tick: 18 },
    tickPadding: 2,
  },
  m: {
    height: 140,
    padding: { top: 12, bottom: 16, left: 0, right: 0 },
    domainPaddingX: 10,
    yFactor: 1,
    barWidth: 28,
    cornerRadius: { top: 1, bottom: 1 },
    fontSize: { tick: 10 },
    tickPadding: 2,
  },
  l: {
    height: 100,
    padding: { top: 0, bottom: 12, left: 0, right: 0 },
    domainPaddingX: 0,
    yFactor: 1,
    barWidth: 31,
    cornerRadius: { top: 2, bottom: 2 },
    fontSize: { tick: 6 },
    tickPadding: 3,
  },
  xl: {
    height: 100,
    padding: { top: 0, bottom: 12, left: 0, right: 0 },
    domainPaddingX: 0,
    yFactor: 1,
    barWidth: 32,
    cornerRadius: { top: 2, bottom: 2 },
    fontSize: { tick: 5 },
    tickPadding: 3,
  },
};

export const minimalWebConfigs: Partial<
  Record<ScreenSize, Partial<ChartConfig>>
> = {
  m: {
    height: 75,
    padding: { top: 0, bottom: 14, left: 0, right: 0 },
    barWidth: 56,
    cornerRadius: { top: 3, bottom: 3 },
  },
  l: {
    height: 75,
    cornerRadius: { top: 3, bottom: 3 },
  },
  xl: {
    height: 75,
    cornerRadius: { top: 3, bottom: 3 },
  },
};
